/* src/app/common/components/register-modal/register-modal.component.scss */
.otp-input {
  width: 48px;
  height: 48px;
  text-align: center;
  font-size: 18px;
  border-radius: 6px;
  border: none;
  background-color: var(--otp-input-bg);
}
.otp-input:focus {
  border-color: transparent;
  outline: none;
  box-shadow: 0 0 0 2px rgba(181, 139, 60, 0.2);
}
.modal-footer-note {
  background: var(--bg-light-pink);
  padding: 10px;
  font-size: 13px;
  color: var(--color-primary);
  border-radius: 0 0 12px 12px;
}
.wrapper-div {
  padding: 20px 30px;
}
.font-15-px {
  font-size: 15px;
}
.text-gray-otp {
  color: var(--color-gray12);
  font-size: 12px;
  font-weight: 500;
}
.consent-box {
  max-height: 123px;
  overflow-y: auto;
  padding: 0px;
}
.aadhaar-wrapper {
  position: relative;
}
.aadhaar-wrapper input {
  padding-right: 40px;
}
.aadhaar-wrapper i {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #555;
}
.ration-link {
  transition: all 0.3s ease;
  text-decoration: underline;
}
.ration-link:hover {
  color: var(--bg-grediant-orange-theme) !important;
}
.read-more-link {
  position: absolute;
  right: 10px;
  bottom: -5px;
  font-size: 13px;
  color: var(--text-blue);
  cursor: pointer;
  text-decoration: underline;
  background-color: var(--body-background);
  padding: 0px;
  border-radius: 0;
  background:
    linear-gradient(
      to right,
      transparent,
      white 30%);
  padding-left: 40px;
}
/*# sourceMappingURL=register-modal.component-5AJVXBTP.css.map */
